export class PersistenceError extends Error {
  constructor(message: string, cause?: unknown) {
    super(message, cause === undefined ? undefined : { cause })
    this.name = 'PersistenceError'
  }
}

export class PersistenceUnavailableError extends PersistenceError {
  constructor(message = 'Browser storage is unavailable.', cause?: unknown) {
    super(message, cause)
    this.name = 'PersistenceUnavailableError'
  }
}

export class SharedInboxReadError extends PersistenceError {
  constructor(message = 'Could not read photos shared into the app.', cause?: unknown) {
    super(message, cause)
    this.name = 'SharedInboxReadError'
  }
}

export class SharedInboxWriteError extends PersistenceError {
  constructor(cause?: unknown) {
    const quotaExceeded = cause instanceof DOMException && cause.name === 'QuotaExceededError'
    super(
      quotaExceeded
        ? 'This browser does not have enough storage space to receive the shared photos.'
        : 'Could not store photos shared into the app.',
      cause,
    )
    this.name = 'SharedInboxWriteError'
  }
}

export class PersistenceReadError extends PersistenceError {
  constructor(message = 'Could not read recent edits from this browser.', cause?: unknown) {
    super(message, cause)
    this.name = 'PersistenceReadError'
  }
}

export class PersistenceWriteError extends PersistenceError {
  constructor(cause?: unknown) {
    const quotaExceeded = cause instanceof DOMException && cause.name === 'QuotaExceededError'
    super(
      quotaExceeded
        ? 'This browser does not have enough storage space to save the edit.'
        : 'Could not save the edit in this browser.',
      cause,
    )
    this.name = 'PersistenceWriteError'
  }
}

export class InvalidRecentEditError extends PersistenceReadError {
  constructor(
    readonly detail: string,
    readonly recordId?: string,
  ) {
    super(`A saved edit is invalid: ${detail}`)
    this.name = 'InvalidRecentEditError'
  }
}
